import React from 'react';
import {useFormContext} from "react-hook-form";
import CustomSelect from "../../../../widgets/inputs/CustomSelect";
import {tipologieQuarantena, tipoMonitortaggio} from "../../../../../utils/arrays/Generics";
import {MenuItem} from "@mui/material";
import Grid from "@mui/material/Grid";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {bigNoteRegisterNotRequired} from "../../../../../utils/RegisterUtils";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import CustomText from "../../../../widgets/inputs/CustomText";

export const QuarantenaGrid = () => {
	const {errors, control, register} = useFormContext();
	
	return (
		<React.Fragment>
			<Grid item xs={12} sm={4}>
				<CustomDateInput
					name={"dataInizio"}
					label={"Data inizio"}
					control={control}
					defaultValue={null}
					rules={{required: true}}
					error={errors["dataInizio"]}
				/>
			</Grid>
			<Grid item xs={12} sm={4}>
				<CustomDateInput
					name={"dataFine"}
					label={"Data fine"}
					control={control}
					defaultValue={null}
					rules={{required: false}}
					error={errors["dataFine"]}
				/>
			</Grid>
			<Grid item xs={12} sm={4}>
				<CustomSelect
					label={"Tipo paziente"}
					control={control}
					defaultValue={"Caso indice"}
					autoFocus={true}
					rules={{required: true}}
					name={"tipoContatto"}
					error={errors?.["tipoContatto"]}
				>
					<MenuItem value={"Caso indice"}>Caso indice</MenuItem>
					<MenuItem value={"Contatto convivente"}>Contatto convivente</MenuItem>
					<MenuItem value={"Contatto stretto"}>Contatto stretto o NON convivente</MenuItem>
				</CustomSelect>
			</Grid>
			<Grid item xs={12} sm={5}>
				<CustomSelect
					label={"Tipo ordinanza"}
					control={control}
					defaultValue={tipologieQuarantena[0]}
					autoFocus={false}
					rules={{required: true}}
					name={"tipo"}
					error={errors?.["tipo"]}
				>
					{tipologieQuarantena.map((val, key) => {
						return (
							<MenuItem value={val} key={key}>
								{val === "Quarantena" ? "Autosorveglianza" : val}
							</MenuItem>
						);
					})}
				</CustomSelect>
			</Grid>
			<Grid item xs={12} sm={5}>
				<CustomSelect
					label={"Tipo di monitoraggio"}
					control={control}
					defaultValue={tipoMonitortaggio[0]}
					autoFocus={false}
					rules={{required: true}}
					name={"tipoMonitoraggio"}
					error={errors?.["tipoMonitoraggio"]}
				>
					{tipoMonitortaggio.map((val, key) => {
						return (
							<MenuItem value={val} key={key}>
								{val}
							</MenuItem>
						);
					})}
				</CustomSelect>
			</Grid>
			<Grid item xs={12} sm={2}>
				<CustomSelect
					label={"Score"}
					control={control}
					autoFocus={false}
					defaultValue={1}
					rules={{required: true}}
					name={"score"}
					error={errors["score"]}
				>
					{[0, 1, 2, 3, 4].map((val, key) => {
						return (
							<MenuItem value={val} key={key}>
								{val}
							</MenuItem>
						);
					})}
				</CustomSelect>
			</Grid>
			<Grid item xs={12}>
				<CustomText
					name={"aliasFocolaio"}
					label={"Nome da assegnare all'associazione"}
					rules={{required: false}}
					error={errors["aliasFocolaio"]}
					control={control}
				/>
			</Grid>
			<Grid item xs={12}>
				<CustomMultiText
					inputRef={register(bigNoteRegisterNotRequired)}
					label={"Note aggiuntive"}
					autofocus={false}
					name={"note"}
					error={errors["note"]}
				/>
			</Grid>
		</React.Fragment>
	);
};
